import AssetTypeList from './AssetTypeList';

export default AssetTypeList;
export * from './AssetTypeList';
